import React, {FC} from 'react'
import {useOrderAuthEf} from "@/src/components/OrderAuthModal/useOrderAuthEf";
import {useSearchParams} from "next/navigation";
import {PROCESS_INSTANCE_QUERY, PRODUCT_INSTANCE_QUERY} from "@/src/shared/const";
import {FailedLinkStatus} from "@/src/components/OrderAuthModal/model";
import {FAILED_LINK_STATUSES} from "@/src/components/OrderAuthModal/constants";
import FailedLinkModal from "@/src/components/OrderAuthModal/components/FailedLinkModal";
import ConfirmModal from "@/src/components/OrderAuthModal/components/ConfirmModal";
import OtpModal from "@/src/components/OrderAuthModal/components/OtpModal";


const OrderAuthModal: FC = () => {
    const searchParams = useSearchParams();
    const processInstanceId: FailedLinkStatus | string | null = searchParams.get(PROCESS_INSTANCE_QUERY);
    const productSlug: FailedLinkStatus | string | null = searchParams.get(PRODUCT_INSTANCE_QUERY);

    const {
        otpForm,
        otpInfo,
        formError,
        handleCloseErrorModal,
        handleCloseOtpModal,
        showConfirmModal,
        handleCloseConfirmModal,
        email,
        resendEmailCode,
        sendEmailCode,
        verifyOtpCode,
        isLoadingEmailCode,
        isLoadingVerifyCode
    } = useOrderAuthEf({ processInstanceId, productSlug });

    if (!processInstanceId) return null;

    if (FAILED_LINK_STATUSES.includes(processInstanceId as FailedLinkStatus)) return <FailedLinkModal processInstanceId={processInstanceId as FailedLinkStatus} onCancel={handleCloseErrorModal} />
    if (!productSlug) return <FailedLinkModal processInstanceId={"not-found"} onCancel={handleCloseErrorModal} />

    if (formError)
    return <FailedLinkModal
        processInstanceId={processInstanceId as FailedLinkStatus}
        customContent={{ title: "Виникла помилка", description: formError ?? "" }}
        onCancel={handleCloseErrorModal}
    />

    return (<>
        <OtpModal
            form={otpForm}
            otpInfo={otpInfo}
            email={email}
            isLoading={isLoadingVerifyCode}
            onResend={resendEmailCode}
            onAccept={verifyOtpCode}
            onCancel={handleCloseOtpModal}
        />
        <ConfirmModal
            isOpen={showConfirmModal}
            email={email}
            isLoading={isLoadingEmailCode}
            onAccept={sendEmailCode}
            onCancel={handleCloseConfirmModal}
        />
    </>)
}

export { OrderAuthModal }
